import {
    ReportTableActionMenuTypesEnum,
    ReportTableColumn,
    ReportTableConfigInterface
} from 'appShared/components/report-table';
import {BaseControl, propertyOf} from 'appShared/classes';
import {
    ConstraintsCollection,
    PlatformFrontendFilterModel,
    PlatformFrontendInterface,
    ReportFilterConstraintsEnum
} from '@spa/api';
import {DialogButtonTypesEnum, DialogConfigInterface, Pagination} from 'appShared/components';

export const PanelPlatformFrontendsDataTableConfig: ReportTableConfigInterface = {
    rows: [],
    columns: [
        new ReportTableColumn({
            label: 'Name',
            selector: propertyOf<PlatformFrontendInterface>('name'),
        }),
        new ReportTableColumn({
            label: 'Description',
            selector: propertyOf<PlatformFrontendInterface>('description')
        }),
        new ReportTableColumn({
            label: 'Platfrom Name',
            selector: propertyOf<PlatformFrontendInterface>('platformName'),
        }),
        new ReportTableColumn({
            label: 'Price',
            selector: propertyOf<PlatformFrontendInterface>('price'),
        }),
        new ReportTableColumn({
            label: 'Currency',
            selector: propertyOf<PlatformFrontendInterface>('currency'),
        }),
    ],
    hiddenColumnIds: [],
    actionMenu: false,
    actionMenuType: ReportTableActionMenuTypesEnum.Buttons,
    actionMenuItems: []
};

export const RemovePlatformFrontendsControls = (): BaseControl<string | number | boolean>[] => {
    return [];
};

export const RemovePlatformFrontendDialogConfig = (): DialogConfigInterface => {
    return {
        process: {
            loading: false,
            finished: false,
            failed: false,
            failedMessage: '',
            succeedMessage: ''
        },
        buttons: [
            {
                type: DialogButtonTypesEnum.Cancel
            },
            {
                type: DialogButtonTypesEnum.Confirm,
                hidden: true,
                customText: 'Remove'
            }
        ],
        buttonsDisabled: false,
        buttonsHidden: false,
        disabledCloseBtn: true
    };
};

export const defaultPlatformFrontendInitialFilterModel = (itemsPerPage = Pagination.defaultItemsPerPage) => {
    const filter = getDeletablePlatformFrontendFilterModel(itemsPerPage);

    filter.addConstraintItem(
        ReportFilterConstraintsEnum.Equal,
        'deleted',
        'false'
    );

    return filter;
};

export const getDeletablePlatformFrontendFilterModel = (itemsPerPage = Pagination.defaultItemsPerPage) => {
    return new PlatformFrontendFilterModel(
        new ConstraintsCollection(),
        Pagination.defaultPagesChunk - 1,
        PlatformFrontendFilterModel.getCreatedTimeSelector(),
        Pagination.calculateItemsPerPagesChunk(itemsPerPage),
        false
    );
};
